import { Box, Paper, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useRefreshItemsOnRunComplete, useReleaseCheckItems } from '../../api/release-check-api'
import CategoryPanel from './CategoryPanel'
import PanelNav from './PanelNav'
import ResultsTable from './ResultsTable'
import StatusHeader from './StatusHeader'
import { usePanelState } from './usePanelState'

const DashboardPage = () => {
  const { t } = useTranslation()
  const [items] = useReleaseCheckItems()
  const { panel, setPanel } = usePanelState()
  useRefreshItemsOnRunComplete()

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
        {t('releaseCheck.title', 'Release Checklist')}
      </Typography>

      <Stack direction="row" spacing={2} sx={{ alignItems: 'flex-start' }}>
        <Paper variant="outlined" sx={{ width: 260, flexShrink: 0 }}>
          <PanelNav panel={panel} items={items} onSelect={setPanel} />
        </Paper>

        <Box sx={{ flex: 1, minWidth: 0 }}>
          {panel === 'status' ? (
            <StatusHeader />
          ) : panel === 'all' ? (
            <ResultsTable />
          ) : (
            <CategoryPanel category={panel} />
          )}
        </Box>
      </Stack>
    </Box>
  )
}

export default DashboardPage
